import { isEmpty, type objectUtils } from '@festina-life/core'
import { Alert } from '@festina-life/ui/feedback'
import { useTranslate } from '@festina-life/ui/hooks'
import { Table, TBody, Td, THead, Tr } from '@festina-life/ui/listsAndTables'

import { DiffObjectRows } from './DiffObjectRows'

type Props<T> = {
  diff: objectUtils.Diff<T>
}

export const DiffObjectView = <T,>({ diff }: Props<T>) => {
  const translate = useTranslate()

  return isEmpty(diff) ? (
    <Alert severity="info" className="mb-2">
      {translate('changeCommitmentModalButton.confirm.noChanges')}
    </Alert>
  ) : (
    <Table>
      <THead>
        <Tr>
          <Td>{translate('changeCommitmentModalButton.confirm.field')}</Td>
          <Td>{translate('changeCommitmentModalButton.confirm.removed')}</Td>
          <Td>{translate('changeCommitmentModalButton.confirm.added')}</Td>
        </Tr>
      </THead>
      <TBody>
        <DiffObjectRows diff={diff} depth={0} />
      </TBody>
    </Table>
  )
}
